import {withStyles} from '@material-ui/core/styles';
import MuiCard, {CardClassKey, CardProps} from '@material-ui/core/Card';
import MuiCardHeader from '@material-ui/core/CardHeader';

export const Card = withStyles<
    CardClassKey,
    any,
    CardProps & {type: 'number' | 'currency' | 'percent' | 'text'}
>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        padding: p => (p.type === 'percent' ? 0 : theme.spacing(3)),
        minHeight: theme.spacing(21),
        position: 'relative',

        '& + &': {
            marginTop: '2px'
        },

        [theme.breakpoints.up('lg')]: {
            padding: '22px 15px',
            minHeight: theme.spacing(23.5)
        }
    }
}))(MuiCard);

export const CardHeader = withStyles(theme => ({
    root: {
        zIndex: 2
    },
    title: {
        fontWeight: 400,
        width: '100%',
        textTransform: 'uppercase',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    },
    subheader: {
        fontWeight: 500,
        marginTop: theme.spacing(1)
    },
    content: {
        width: '100%'
    }
}))(MuiCardHeader);
